<template>
  <div>
    <b-row v-for="(n, index) in multPmts" :key="index" class="py-1">
      <form-read-group-label-input
        v-if="index === multPmts.length - 1"
        :isMandatory="true"
        :idLabel="$t('common.amnt')"
        :placeholderValue="'Amount ('+ ccy + ')'"
        :inputValue="parseFloat(parseFloat(n.amount).toFixed(2)).toString()"
        type="number"> <!--'common.amnt'-->
      </form-read-group-label-input>
      <form-write-group-label-input
          v-else
          :isMandatory="true"
          :idLabel="$t('common.amnt')"
          :placeholderValue="$t('common.amnt') + ' ('+ ccy + ')'"
          v-model="n.amount"
          inputType="number">
      </form-write-group-label-input>
      <form-write-group-label-input :isMandatory="true"
        :idLabel="$t('common.date_label')" :placeholderValue="$t('common.slct_date')"
        v-model="n.date" :inputType="'date'"  v-bind:id="'negotiationDateInput' + index">
      </form-write-group-label-input>
      <!--
      <b-col xs="6">
        <input class="form-control" name="amount" :placeholder="'Amount ('+ ccy + ')'" style='display:inline-block'
               type="number" v-model="n.amount" v-bind="{readonly : index === multPmts.length - 1}">
        </input>
      </b-col>
      <b-col xs="6">
        <input class="form-control" type="date" v-bind:id="'negotiationDateInput' + index"
               placeholder="Select a date" v-model="n.date">
      </b-col>-->
    </b-row>
    <div class="form-group row justify-content-end">
      <div class="col-8">
        <div style="text-align:right;font-weight: bold; font-size:12px; width: 100%;">
            {{ $t('regles_metier.rqstng') }} <font :color="sumColor">{{sum + ccy}}</font> {{ $t('regles_metier.of_label') }}
            <!--En mettant 0 en bas par défaut tant que l'amount n'est pas rempli -->
            <font color="#12bcf1">{{amount==''?'0' + ccy:amount +ccy}}</font>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'

export default {
  name: 'EcheancierForm',
  props: ['numPay', 'min', 'amount', 'ccy', 'value', 'deposit'], // value = multPmts (v-model)
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  computed: {
    multPmts: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    sumColor () {
      if (Number(this.sum) === Number(this.amount)) {
        return '#12bcf1'
      } else {
        return 'red'
      }
    },
    sum: function () {
      let sum = 0
      for (let i = 0; i < this.multPmts.length; i++) {
        sum += (this.multPmts[i].amount === '' || this.multPmts[i].amount == null) ? 0
        : parseFloat(parseFloat((typeof this.multPmts[i].amount === 'number'
                    ? this.multPmts[i].amount.toString()
                    : this.multPmts[i].amount).replace(/\s/g, '')).toFixed(2))
      }
      sum += (this.deposit == null || this.deposit === '') ? 0 : parseFloat(this.deposit) // On ajoute le deposit, correspondant a l'echeance 0
      return parseFloat(sum.toFixed(2))
    }
  },
  watch: {
    numPay (num) {
      if (num >= this.min) {
        let multi = this.defineArray(num)
        multi = this.adjustLastAmount(multi)
        this.updateInstallments(multi)
      }
    },
    deposit () {
      this.updateInstallments(this.adjustLastAmount(this.multPmts))
    },
    amount () {
      this.updateInstallments(this.adjustLastAmount(this.multPmts))
    },
    value: {
      handler: function () {
        this.updateInstallments(this.adjustLastAmount(this.multPmts))
      },
      deep: true
    }
  },
  created () {
    if (this.multPmts.length === 0) {
      this.updateInstallments(this.defineArray(this.numPay))
    }
  },
  methods: {
    updateInstallments (multPmts) {
      this.$emit('input', multPmts)
    },
    defineArray (n) {
      let multPmts = []
      for (let i = 0; i < n; i++) {
        multPmts.push({
          date: moment().format('YYYY-MM-DD'),
          amount: ''
        })
      }
      return multPmts
    },
    adjustLastAmount (multi) {
      if (this.numPay > 0) {
        let deposit = (!this.deposit) ? 0 : this.deposit
        let amount = (!this.amount) ? 0 : this.amount
        let sum = 0
        let multPmts = multi
        for (let i = 0; i < multPmts.length - 1; i++) {
          if (multPmts[i].amount !== '' && multPmts[i].amount > 0) {
            sum += Number(multPmts[i].amount)
          }
        }

        let lastAmount = amount - deposit - sum
        if (lastAmount < 0) {
          lastAmount = 0
        }
        multPmts[multPmts.length - 1].amount = lastAmount
        return multPmts
      }
      return this.multPmts
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// EcheancierForm.vue?2256e052